import * as React from 'react';
import { __ } from 'react-i18n';
import { FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { Button, ButtonLink } from '../General/Button';
import { SvgIcon, IconType } from '../General/SvgIcon';

interface Props {
  handleStepChange: (step: number) => void;
  handleSendToEmailClick: () => void;
  isDemand: boolean;
}

function CartFooter({
  handleStepChange,
  handleSendToEmailClick,
  isDemand,
}: Props) {
  return (
    <>
      <DesktopFooterWrapper>
        <BackLink to={'/'}>{__('Pokračovať v nakupovaní')}</BackLink>
        <RightFooterWrapper>
          {/* TURNED OFF */}
          {/* <BackButton onClick={handleSendToEmailClick}>
            <SvgIcon
              icon={IconType.upload}
              alt={__('Odoslať na email')}
              width={16}
              height={16}
              marginRight={16}
              fill={'black'}
              cursor="pointer"
            />
            {__('Odoslať na email')}
          </BackButton> */}
          <NextButton
            // tslint:disable-next-line:jsx-no-lambda
            onClick={() => handleStepChange(2)}
          >
            {__('Vyplniť osobné údaje')}
          </NextButton>
        </RightFooterWrapper>
      </DesktopFooterWrapper>
      <MobileFooterWrapper>
        <RightFooterWrapper>
          <NextButton
            // tslint:disable-next-line:jsx-no-lambda
            onClick={() => handleStepChange(2)}
          >
            {__('Vyplniť osobné údaje')}
          </NextButton>
          {/* <BackButton onClick={handleSendToEmailClick}>
            <SvgIcon
              icon={IconType.upload}
              alt={__('Odoslať na email')}
              width={16}
              height={16}
              marginRight={16}
              fill={'black'}
              cursor="pointer"
            />
            {__('Odoslať na email')}
          </BackButton> */}
          <BackLink to={'/'}>{__('Pokračovať v nakupovaní')}</BackLink>
        </RightFooterWrapper>
      </MobileFooterWrapper>
    </>
  );
}

const FooterWrapper = styled(FlexRowCenterVertical)`
  justify-content: space-between;
  max-width: ${rem(1148)};
  margin: 0 auto;
  width: 100%;
`;

const DesktopFooterWrapper = styled(FooterWrapper)`
  ${({ theme }) => theme.mediab.m760`
    display: none;
  `}
`;

const MobileFooterWrapper = styled(FooterWrapper)`
  display: none;

  ${({ theme }) => theme.mediab.m760`
    display: flex;
    flex-flow: column;
  `}
`;

const RightFooterWrapper = styled(FlexRowCenterVertical)`
  justify-content: flex-end;
  width: 100%;

  ${({ theme }) => theme.mediab.m760`
    flex-flow: column;
  `}
`;

const ButtonCss = css`
  height: ${rem(48)};
  margin: ${rem(15)} 0 0;
  padding: ${rem(8)};
  width: 100%;
  max-width: ${rem(320)};
  color: ${({ theme }) => theme.colors.black};
  font-size: ${rem(14)};
  border-radius: ${rem(2)};
  margin: 0;

  &:disabled {
    background-color: #f9f9f9;
    color: #cccccc;
  }

  ${({ theme }) => theme.mediab.m760`
    max-width: ${rem(288)};
    margin-bottom: ${rem(16)}
  `}

  ${({ theme }) => theme.mediab.s450`
    max-width: initial;
  `}
`;

const NextButton = styled(Button)`
  ${ButtonCss};
  background-color: ${({ theme }) => theme.colors.secondary};
  max-width: ${rem(238)};
`;

const BackButton = styled(NextButton)`
  background-color: ${({ theme }) => theme.colors.white};
  border: ${({ theme }) => theme.borders.primary};
  max-width: ${rem(216)};
  margin-right: ${rem(16)};

  ${({ theme }) => theme.mediab.m760`
    margin-right: 0;
  `}
`;

const BackLink = styled(ButtonLink)`
  ${ButtonCss};
  background-color: ${({ theme }) => theme.colors.white};
  border: ${({ theme }) => theme.borders.primary};
  max-width: ${rem(238)};
`;

export { CartFooter };
